import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import EmptyPage from '../../widgets/EmptyPage';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import WaitDialog from '../../widgets/WaitDialog';
import ReportExcel from '../../utils/excel/reportAdmin';

export default class Stats extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.eventslist = [];
    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false
    }

    this.grid = 2;
    this.pdfElements = [];

    this.investorsList = [];
    this.pageTitle = "Investors";
    this.brokerId = undefined;

    this.state = {

    };

  }

  async componentDidMount(){
    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });
    this.setState({waitDialogVisible: true});
    if (currentEventName != '' && currentEventName != undefined){
      await ReportExcel();
    }
    this.setState({waitDialogVisible: false});

  }


  render () {

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });

    if (currentEventName == '' || currentEventName == undefined){
      return <EmptyPage />;
    }

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title="Stats" />
        
        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()}/>

        </LoadingOverlay>
      </>
    );
  }

}

